/** KAN-735: баланс OpenRouter в $ и ₽ со временем обновления; при ошибке "Нет данных: <error>". */
import { formatDateTime } from '@/lib/expenses';
import { formatRub, formatUsd } from '@/lib/money';
import type { OpenRouterBalance } from '@/types/expenses';

export function OpenRouterBalanceCard({ balance }: { balance: OpenRouterBalance }): JSX.Element {
  const hasBalance = balance.balance_usd !== null && balance.balance_usd !== undefined;
  const updated = formatDateTime(balance.fetched_at);
  return (
    <div className="rounded-lg border bg-white p-4" data-testid="openrouter-balance">
      <p className="text-sm font-medium text-gray-900">Баланс OpenRouter</p>
      {balance.error || !hasBalance ? (
        <p className="mt-1 text-sm text-amber-700">
          Нет данных{balance.error ? `: ${balance.error}` : ''}
        </p>
      ) : (
        <>
          <p className="mt-1 text-2xl font-semibold tabular-nums text-gray-900">
            {formatUsd(balance.balance_usd as number)}
            {balance.balance_rub !== null && (
              <span className="ml-2 text-base font-normal text-gray-500">
                {formatRub(balance.balance_rub)}
              </span>
            )}
          </p>
          {balance.total_credits_usd !== null && balance.total_usage_usd !== null && (
            <p className="mt-1 text-xs text-gray-500">
              Пополнено {formatUsd(balance.total_credits_usd)}, израсходовано{' '}
              {formatUsd(balance.total_usage_usd)}
            </p>
          )}
        </>
      )}
      {updated && <p className="mt-1 text-xs text-gray-400">Обновлено {updated}</p>}
    </div>
  );
}
